(function(){
  'use strict';

  // ── Accordion ──────────────────────────────────────
  document.addEventListener('click', function(e){
    var head = e.target.closest('.acc-head');
    if (!head) return;
    var row = head.closest('.acc-row');
    if (row) row.classList.toggle('open');
  });

  // ── Mobile hamburger nav ──────────────────────────────
  document.addEventListener('click', function(e){
    var t = e.target.closest('.nav-toggle');
    if (!t) return;
    var ul = document.querySelector('header.site .nav ul');
    if (!ul) return;
    var open = ul.classList.toggle('open');
    t.setAttribute('aria-expanded', String(open));
  });
  // Close mobile nav when a link inside it is tapped
  document.addEventListener('click', function(e){
    var a = e.target.closest('header.site .nav ul a');
    if (!a) return;
    var ul = a.closest('ul');
    var t = document.querySelector('.nav-toggle');
    if (ul) ul.classList.remove('open');
    if (t) t.setAttribute('aria-expanded', 'false');
  });

  // ── PDP form: colourway switcher (changes which product form is visible) ──
  function pdpInit(){
    var sel = document.querySelector('[data-pdp-app]');
    if (!sel) return;

    var ways = sel.querySelectorAll('[data-cway]');
    var ropes = sel.querySelectorAll('[data-rope]');
    var qtys = sel.querySelectorAll('[data-qty]');
    var total = sel.querySelector('[data-running-total]');
    var unitPrice = parseFloat(sel.dataset.unitPrice || '54');
    var qtyHints = {
      1: "A solid solo CHUUG.",
      2: "Bought one — should've bought two. — 5% off.",
      3: "A trio for the lads. — 10% off.",
      4: "Stocking the workshop. — 12% off.",
      5: "Fellowship rates. — 15% off."
    };
    var qtyDiscount = [0, 0, 0.05, 0.10, 0.12, 0.15];

    function setActive(group, target){
      group.forEach(function(b){ b.classList.toggle('active', b === target); });
    }
    function showFormFor(handle){
      sel.querySelectorAll('[data-product-form]').forEach(function(f){
        f.style.display = (f.dataset.productForm === handle) ? '' : 'none';
      });
    }
    function setQty(n){
      var hint = sel.querySelector('[data-qty-hint]');
      if (hint) {
        var t = qtyHints[n] || qtyHints[1];
        if (t.indexOf('—') > -1) {
          var bits = t.split('—');
          hint.innerHTML = bits[0] + '— <span class="save">' + bits[1].trim() + '</span>';
        } else {
          hint.textContent = t;
        }
      }
      var disc = qtyDiscount[n] || 0;
      var sub = (unitPrice * n * (1 - disc)).toFixed(2);
      var was = (unitPrice * n).toFixed(2);
      if (total) {
        // No strikethrough — set discount renders as savings copy in qty hint, not crossed-out price.
        var inner = '£' + sub;
        if (disc > 0) inner += ' <span class="set-savings">−£' + (parseFloat(was) - parseFloat(sub)).toFixed(2) + ' SAVED</span>';
        total.innerHTML = inner;
      }
      sel.querySelectorAll('[data-product-form]').forEach(function(f){
        var qInput = f.querySelector('input[name="quantity"]');
        if (qInput) qInput.value = n;
      });
    }

    ways.forEach(function(b){
      b.addEventListener('click', function(){
        setActive(ways, b);
        showFormFor(b.dataset.cway);
        // also swap main image
        var newImg = b.dataset.cwayImg;
        var mainImg = sel.querySelector('[data-main-shot] img');
        var marker = sel.querySelector('[data-marker]');
        if (newImg && mainImg) mainImg.src = newImg;
        if (marker) marker.textContent = 'CHUUG № 01 · ' + (b.dataset.cwayName || '').toUpperCase() + ' / ' + (sel.querySelector('[data-rope].active')?.dataset.ropeName || 'NATURAL').toUpperCase();
      });
    });
    ropes.forEach(function(b){
      b.addEventListener('click', function(){ setActive(ropes, b); });
    });
    qtys.forEach(function(b){
      b.addEventListener('click', function(){
        setActive(qtys, b);
        setQty(parseInt(b.dataset.qty, 10) || 1);
      });
    });

    // Initial input — always uppercase, single letter
    var initInput = sel.querySelector('[data-initial-input]');
    if (initInput) {
      initInput.addEventListener('input', function(){
        this.value = this.value.toUpperCase().replace(/[^A-Z]/g, '').slice(0, 1);
        sel.querySelectorAll('input[name="properties[Initial]"]').forEach(function(i){ i.value = initInput.value; });
      });
    }

    setQty(parseInt(sel.dataset.initialQty, 10) || 1);

    // Thumbnails
    var thumbs = sel.querySelectorAll('[data-thumb]');
    thumbs.forEach(function(t){
      t.addEventListener('click', function(){
        var src = t.dataset.thumb;
        var mainImg = sel.querySelector('[data-main-shot] img');
        if (src && mainImg) mainImg.src = src;
        thumbs.forEach(function(x){ x.classList.toggle('active', x === t); });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pdpInit);
  } else {
    pdpInit();
  }
})();
